module.exports = __webpack_public_path__ + "img/avatar_recruiter.aed932d6.svg";